import { Plus } from "lucide-react";
import { Link, useSearchParams } from "react-router-dom";
import { useGetInvestments } from "@/features/applications/repositories/investment-repository";
import { useState } from "react";




import Button from "@/components/buttons/Button";
import Table from "@/components/Table";
import ApplicationsFilters from "../applications-filters";
import InvestmentsApplicationsItem from "./investments-applications-item";
import Pagination from "@/components/Pagination";



export default function InvestmentsApplications() {
    const [searchParams] = useSearchParams();

    const [page, setPage] = useState<number>(0);
    const columns = [
        "Application ID", 
        "Clients",
        "Project Name", 
        "Investment Amount",
        "Status",
        "Actions"
    ]
    // page is 0-based locally (matches the paginator); the API is 1-based, so send page + 1.
    const { investiments, isLoading} = useGetInvestments({
        pager: { page: page + 1, size: 10 },
        filter: Object.fromEntries(searchParams.entries())

    })

    return (
        <div className="mt-5 px-4">

            <div className="flex justify-between items-center">
                <ApplicationsFilters />
                <Link to={"/applications/apply"}>
                    <Button
                        intent="primary"
                        size="md"
                        leftIcon={<Plus size={20} />}
                    >
                        New Applications
                    </Button>
                </Link>
            </div>
            <Table.Container>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            {
                                columns.map((header) => (
                                    <Table.Head key={header}>
                                        {header}
                                    </Table.Head>
                                ))
                            }
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {
                            isLoading && (
                            <Table.Loading columns={columns.length} />
                        )}

                        {
                            !isLoading && investiments && investiments.results.length === 0 && (
                                <Table.Empty />
                            )
                        }

                        {
                            !isLoading && investiments && (
                                investiments.results.map((item:any, index: number) => (
                                <InvestmentsApplicationsItem investment={item} key={index} />
                            ))
                        )}
                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.Cell colSpan={columns.length}>
                                <div className="flex justify-between items-center font-light">
                                    <div>
                                        {page + 1} of &nbsp;
                                        {investiments?.pagination?.last_page}
                                    </div>
                                    <Pagination
                                        currPage={page}
                                        setCurrPage={(value) => setPage(value)}
                                        pageCount={investiments?.pagination?.last_page ?? 0}
                                    />
                                </div>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
            </Table.Container>
        </div>
    )
}